function flattenRelatedInternal(product, to) {
    if (product) {
        to.push(product);

        if (product.related) {
            product.related.forEach((p) => {
                flattenRelatedInternal(p, to);
            });
        }
    }
}

/**
 * Flattens the hierarchy of related products.
 */
// eslint-disable-next-line import/prefer-default-export
export function flattenRelated(controller) {
    const products = [];

    if (controller && controller.blueprint && controller.blueprint.relatedProducts) {
        controller.blueprint.relatedProducts.forEach((p) => {
            flattenRelatedInternal(p, products);
        });
    }

    return products;
}

/**
* If the placement has a placeholder component, use that
* If the placement has a .preferred === true (and isAvailable) component, use that
* Otherwise use first isAvailable component
*/

export const getPlaceholderForPlacement = (placement, viewController) => {
    if (!Array.isArray(placement?.components)) {
        return undefined;
    }

    let placeholder = placement.components.find((x) => x.preferred && viewController.isAvailable(x));

    if (!placeholder) {
        placeholder = placement.components.find((x) => x.placeholder && viewController.isAvailable(x));
    }

    if (!placeholder) {
        placeholder = placement.components.find((x) => viewController.isAvailable(x));
    }

    return placeholder;
};
